var render = function render(){var _vm=this,_c=_vm._self._c;return _c('panel',{attrs:{"header":_vm.$t('records.details.panels.hdRadioProperties'),"grid":""}},[_c('text-field',_vm._g(_vm._b({attrs:{"id":"pi_code"}},'text-field',_vm.fieldProperties('pi_code'),false),_vm.fieldHandlers))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }